"use client";

import { Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactInfo() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="1839" id="contact-info" className="relative overflow-hidden bg-primary py-32 md:py-44">
      <div aria-hidden="true" className="pointer-events-none absolute -left-32 top-1/4 h-[640px] w-[640px] opacity-[0.1]">
        <svg viewBox="0 0 600 600" className="h-full w-full">
          <path fill="white" d="M300,80 C420,80 520,180 520,300 C520,420 420,520 300,520 C200,520 120,460 100,360 C80,260 140,160 240,110 C260,98 280,80 300,80 Z" />
        </svg>
      </div>

      <div ref={ref} className={`relative mx-auto max-w-[1360px] px-8 transition-all duration-700 ease-out md:px-16 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-20">
          <div className="order-2 flex flex-col lg:order-1 lg:col-span-5">
            <h1 className="font-default mt-10 text-[clamp(2.5rem,5.5vw,4.5rem)] font-normal leading-[1.02] tracking-tight text-white">
              Your trusted partner for <span className="text-secondary">industrial construction</span>
            </h1>

            <div className="mt-16 space-y-10">
              <div>
                <div className="font-mono text-[0.75rem] uppercase tracking-[0.14em] text-white/70">
                  OFFICE ADDRESS
                </div>
                <address className="font-default mt-4 text-[clamp(1.0625rem,1.25vw,1.1875rem)] not-italic leading-[1.6] text-white">
                  436 South Rd
                  <br />
                  High Point, NC 27262
                </address>
              </div>

              <div className="flex items-center">
                <div className="h-px flex-1 bg-white/20" />
                <div className="ml-2 h-1.5 w-1.5 rounded-lg bg-secondary" />
              </div>
            </div>

            <div className="mt-10 space-y-5">
              <Link to="mailto:info@fabcollc.com" className="group flex items-center gap-4 text-white">
                <Mail className="h-4 w-4 text-secondary" strokeWidth={1.25} />
                <span className="font-default text-base text-white">
                  Email info@fabcollc.com
                </span>
              </Link>

              <Link to="tel:3368850698" className="group flex items-center gap-4 text-white">
                <Phone className="h-4 w-4 text-secondary" strokeWidth={1.25} />
                <span className="font-default text-base text-white">
                  Call (336) 885-0698
                </span>
                <span className="ml-1 flex flex-1 items-center transition-all duration-300 ease-out group-hover:ml-3">
                </span>
              </Link>
            </div>

            <div className="mt-12">
            </div>
          </div>

          <div className="order-1 lg:order-2 lg:col-span-7">
            <div className="relative">
              
              
              
              

              <AspectRatio ratio={4 / 5} className="overflow-hidden rounded-lg border-4 border-white bg-card shadow-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/about-fabco.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/about-fabco.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/about-fabco.jpg-wvc-sizes" alt="FABCO Industrial Construction Facility" className="h-full w-full object-cover" loading="lazy" decoding="async" src="https://quality-seal.10web.cloud/wp-content/uploads/2026/06/CITF-UBC-9-17-14-5-1240x827-Mechatronics.jpg" />
              </AspectRatio>
            </div>

            <div className="mt-5 flex items-center justify-between font-mono text-[0.6875rem] uppercase tracking-[0.14em] text-muted-foreground">
            </div>
          </div>
        </div>
      </div>
    </section>;
}